import * as React from 'react';
// import { WTable } from './WTable';
import { WFormsTableWrapper } from './WFormsTableWrapper';
import { DiffTool } from './helpers/diff_tool';
import * as Moment from 'moment';
import { lazyInject } from '../../services/inversify';
import { DataService } from '../../services/data_service';
import * as classNames from 'classnames';
import btnStyle from '../elements/buttons.less';
import { any } from 'prop-types';

interface WTableStoreProps extends React.ClassAttributes<any> {
    module?: string;
    entity: string;
    data: any;
    WTableData?: any;
}

interface WTableStoreState {
    data: any;
    tableStore: JSX.Element;
    datumSelected: number;
}

export class WTableStore extends React.Component<WTableStoreProps, WTableStoreState>  {
    constructor(props: any) {
        super(props);

        this.renderDatumSelect = this.renderDatumSelect.bind(this);
        this.onChangeDatumSelect = this.onChangeDatumSelect.bind(this);
        this.delSelected = this.delSelected.bind(this);

        this.state = {
            data: this.props.data,
            tableStore: <span>Keine Daten vorhanden</span>,
            datumSelected: 0
        };
    }

    @lazyInject(DataService) private dataService: DataService;

    componentDidMount() {
        this.onChangeDatumSelect();
    }

    // prepareColumns() {
    //     const col = this.props.columns;
    //     const col2 = [];
    //     for (const i of Object.keys(col)) {
    //         if (col[i].Header !== '' && col[i].accessor !== '') {
    //             col2.push(col[i]);
    //         }
    //     }
    //     return col2;
    // }

    // onChangeDatumSelect_OLD(e?: any) {
    //     const data = this.state.data;
    //     let i = 0;
    //     const idxs = Object.keys(data);
    //     if (idxs.length > 0) {
    //         i = parseInt(idxs[0], 10);
    //     }
    //     if (e) {
    //         i = e.target.value;
    //     }
    //     if (data[i]) {
    //         this.setState({
    //             datumSelected: i,
    //             tableStore:
    //                 <WTable
    //                     tableId='showTableStore'
    //                     entity={this.props.entity}
    //                     columns={this.state.columns}
    //                     data={data[i].data}
    //                     onAction={() => { }}
    //                     showPagination={true}
    //                     pageSize={15}
    //                 />
    //         });
    //     }
    // }

    onChangeDatumSelect(e?: any) {
        const data = this.state.data;
        let i = 0;
        const idxs = Object.keys(data);
        if (idxs.length > 0) {
            i = parseInt(idxs[0], 10);
        }
        if (e) {
            i = e.target.value;
        }
        if (data[i]) {
            const storeData = JSON.parse(JSON.stringify(data[i].data));
            const WTableData = JSON.parse(JSON.stringify(this.props.WTableData));
            const dt = new DiffTool(this.props.module);
            const showData = dt.mergeData(this.props.entity, storeData, WTableData);

            this.setState({
                datumSelected: i,
                tableStore:
                    <WFormsTableWrapper
                        module={this.props.module}
                        tableId='showTableStoreDiff'
                        entity={this.props.entity}
                        data={showData}
                        showLegend={true}
                    />
            });
        }
    }

    renderDatumSelect() {
        const data = this.state.data;
        const opt = [];
        for (const i of Object.keys(data)) {
            const datum = Moment.unix(parseInt(data[i].stamp, 10)).format('DD.MM.YYYY HH:mm');
            const kommentar = data[i].kommentar ? (' - ' + data[i].kommentar) : '';
            opt.push(
                <option value={i} key={i}>{datum + kommentar}</option>
            );
        }
        return (
            <div>
                <select
                    style={{ width: '400px' }}
                    value={this.state.datumSelected}
                    onChange={this.onChangeDatumSelect}
                >
                    {opt}
                </select>
                <button
                    className={classNames(btnStyle.delete2, btnStyle.actionButton)}
                    style={{ verticalAlign: 'middle' }}
                    onClick={this.delSelected}
                    title='Löschen'
                >
                </button>
            </div>
        );
    }

    delSelected() {
        const selected = this.state.datumSelected;
        const data = this.state.data;
        if (data[selected] && confirm('Wollen Sie den Datensatz wirklich löschen?')) {
            console.log(data[selected]);
            this.dataService.delTableStore(data[selected].tid, (status: string, suc: boolean) => {
                console.log(status, suc);
                if (status.toLowerCase() === 'true') {
                    delete (data[selected]);
                    this.setState({ data }, () => {
                        this.onChangeDatumSelect();
                    });
                }
            });
        }
    }

    render() {
        return (
            <div>
                {this.renderDatumSelect()}
                <br />
                {this.state.tableStore}
            </div>
        );
    }
}
